import axios from 'axios';

export const updateRequest = async (request, site, productCategories, allCategories) => {
  const body = {
    site,
    host: request.host,
    title: request.title,
    type: request.type,
    config: {
      // productCategories: allCategories
      //   ? []
      //   : productCategories.map((id) => {
      //       return { id };
      //     }),
      about:
        request.type === 2
          ? { ...(request.config?.about || request?.about) }
          : {
              type: 'text',
              data: request.about,
            },
      support: {
        ...(request.config?.support ?? request?.support),
        phones: [...(request.config?.support?.phones ?? request?.phones)],
      },
      address: {
        plain: request.address,
      },
      cv: {
        type: 'text',
        data: request.cv,
      },
      theme: request.theme,
    },
  };
  if (request.type === 2) {
    body.config = {
      ...body.config,
      linkedSites: request.linkedSites,
      subtitle: request.subtitle,
      faq: request.faq,
      banners: request.banners,
      videos: request.videos,
      gallery: request.gallery,
      sliders: request.sliders,
      cover: request.covers,
    };
  }
  const response = await axios.post('/admin/site/edit', body);
  return response.data;
};

export const activatedRequest = async (site) => {
  const body = {
    site,
  };
  const response = await axios.post('/admin/site/activate', body);
  return response.data;
};

export const deactivatedRequest = async (body) => {
  const response = await axios.post('/admin/site/deactivate', body);
  return response.data;
};
